import React, { useContext, useState } from "react";
import styles from "./UserStats.module.css";
import { Link } from "react-router-dom";
import IsAuth from "../../createContext/is-Auth/IsAuthContext";

function UserStats() {
  const [activeStats, setActiveStatus] = useState(true);
  const handleActiveStats = (value) => {
    setActiveStatus(value);
  };
  const {user} = useContext(IsAuth);
  const statItems = [
    { icon: "🥎", value: user?.progress?.totalMatches || 0, label: "Matches played " },
    { icon: "🏆", value: user?.progress?.matchesWon, label: "Matches won" },
    { icon: "🙆‍♂️", value: user?.progress?.totalMatches - user?.progress?.matchesWon, label: "Matches lost" },
    { icon: "🎯", value: Math.ceil(user?.progress?.matchesWon * 100 / (user?.progress?.totalMatches || 1)) , label: "Win%" },
  ];

  return (
    user && (<section className={styles.userStats}>
      <h2 className={styles.statsTitle}>Game Play</h2>
      <div className={styles.statsContainer}>
        <div className={styles.playerInfo}>
          <Link to={'/profile'}><span className={styles.playerName}>{user.userName}</span></Link>
          <img
            src={user.avatar}
            alt={user.userName}
            className={styles.playerAvatar}
          />
        </div>
        
        <div className={styles.statsGrid}>
          {statItems.map((item, index) => (
            <div key={index} className={styles.statItem}>
              <div
                className={styles.statIcon}
                role="img"
                aria-label={item.label}
              >
                {item.icon}
              </div>
              <div className={styles.statValue}>{item.label === "Win%" ? item.value + " %" :item.value}</div>
            </div>
          ))}
        </div>
      </div>
    </section>)
  );
}

export default UserStats;
